import {Store} from './Store.js';
import {Cache} from './Cache.js';
import {fetchQueue} from './../services/Api.js';

const ROLES = (num) => {
  
  switch(num){
    case('0') : return('admin')
    case('1') : return('seller')
    case('2') : return('affiliate')
    case('3') : return('user')
    default : return('user')
  }
};


export const STATUS_ORDER = {
  PENDING: '0',
  SHIPPED: '1',
}

export const STATUS = {
  ACTIVE: '0',
  INACTIVE: '1',
  BLOCKED: '2',
};

const Auth = {
  isAuthenticated: false,
  accessToken: null,
  uid: null,
  authorize(data, cb) {
    let {
      token,
      user:{
        email,
        first_name,
        last_name,
        status,
        role,
        image,
        verify_email,
        primary_user_language,
        agreed_on_terms
      }
      } = data;

    let that = this;
    return new Promise((resolve, reject) => {
      this.isAuthenticated = true;
      this.accessToken = token || null;
      this.photoURL = image || null;
      this.first_name = first_name || null;
      this.last_name = last_name || null;
      this.status = status || null;
      this.role = ROLES(role) || null;
      this.email = email || null;
      this.verify_email = verify_email || false;
      this.agreed_on_terms = agreed_on_terms || null;
      this.primary_user_language = primary_user_language || null;

      if(!this.accessToken) return reject();

      window.localStorage.setItem('accessToken', JSON.stringify(this.accessToken));
      window.localStorage.setItem('photoURL', JSON.stringify(this.photoURL));
      window.localStorage.setItem('first_name', JSON.stringify(this.first_name));
      window.localStorage.setItem('last_name', JSON.stringify(this.last_name));
      window.localStorage.setItem('email', JSON.stringify(this.email));
      window.localStorage.setItem('verify_email', JSON.stringify(this.verify_email));
      window.localStorage.setItem('agreed_on_terms', JSON.stringify(this.agreed_on_terms));
      window.localStorage.setItem('status', JSON.stringify(this.status));
      window.localStorage.setItem('role', JSON.stringify(this.role));
      window.localStorage.setItem('primary_user_language', JSON.stringify(this.primary_user_language));
      if (typeof cb === 'function'){
        cb(resolve);
      }else{
        resolve();
      }

      Store.clear();
      Cache.clear();
    })
  },

  setUnauthenticated(){
    if( typeof window === 'undefined' ) return 
      window.localStorage.setItem('accessToken', false);
    this.isAuthenticated = false;
  },

  async setAgreedOnTerms(){

    let res = await fetchQueue(`auth/agreedOnTerms`, null, 'GET');
    if(!res.message){
      if( typeof window === 'undefined' ) return 
      window.localStorage.setItem('agreed_on_terms', true);
      this.agreed_on_terms = true;
    }else{
      console.log(res)
    }
  },

  init(){

    // polifill localStorage
    if (!('localStorage' in window)) {
      window.localStorage = {
        _data       : {},
        setItem     : function(id, val) { return this._data[id] = String(val); },
        getItem     : function(id) { return this._data.hasOwnProperty(id) ? this._data[id] : undefined; },
        removeItem  : function(id) { return delete this._data[id]; },
        clear       : function() { return this._data = {}; }
      };
    }

    if( typeof window === 'undefined' ) return 
    try {
      this.isAuthenticated = !!JSON.parse(window.localStorage.getItem('accessToken'));
      this.accessToken = JSON.parse(window.localStorage.getItem('accessToken'));
      this.photoURL = JSON.parse(window.localStorage.getItem('photoURL'));
      this.first_name = JSON.parse(window.localStorage.getItem('first_name'));
      this.last_name = JSON.parse(window.localStorage.getItem('last_name'));
      this.email = JSON.parse(window.localStorage.getItem('email'));
      this.verify_email = JSON.parse(window.localStorage.getItem('verify_email'));
      this.agreed_on_terms = JSON.parse(window.localStorage.getItem('agreed_on_terms'));
      this.role = JSON.parse(window.localStorage.getItem('role'));
      this.status = JSON.parse(window.localStorage.getItem('status'));
      this.primary_user_language = JSON.parse(window.localStorage.getItem('primary_user_language'));
    } catch (err) {
      console.error(err)
    }

  },

  signout(cb) {
    return new Promise((resolve, reject) => {
      this.isAuthenticated = false;
      if(typeof window === 'undefined') return  reject();
      window.localStorage.removeItem('accessToken');
      window.localStorage.removeItem('photoURL');
      window.localStorage.removeItem('first_name');
      window.localStorage.removeItem('last_name');
      window.localStorage.removeItem('email');
      window.localStorage.removeItem('verify_email');
      window.localStorage.removeItem('agreed_on_terms');
      window.localStorage.removeItem('uid');
      window.localStorage.removeItem('status');
      window.localStorage.removeItem('role');
      window.localStorage.removeItem('primary_user_language');
      if (typeof cb === 'function') {
        cb(resolve);
      }else{
        resolve()
      }
    })
  }
}
export default Auth;
